import { render, staticRenderFns } from "./OurPrincipalsCMS.vue?vue&type=template&id=90bd7e42&scoped=true"
import script from "./OurPrincipalsCMS.vue?vue&type=script&lang=js"
export * from "./OurPrincipalsCMS.vue?vue&type=script&lang=js"
import style0 from "./OurPrincipalsCMS.vue?vue&type=style&index=0&id=90bd7e42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bd7e42",
  null
  
)

export default component.exports